import { utility } from '@phi/components';
import { PropType, defineComponent, h } from 'vue';

type TextSize =
    'huge'
    | 'bigger'
    | 'big'
    | 'small'
    | 'inherit';

type Weight =
    'normal'
    | 'bold';

export const Text = defineComponent({
    props: {
        as: {
            required: false,
            type: String,
            default: 'span',
        },

        wrap: {
            required: false,
            type: Boolean,
            default: true,
        },

        size: {
            required: false,
            type: String as PropType<TextSize>,
        },

        weight: {
            required: false,
            type: String as PropType<Weight>,
        },
    },

    render() {
        return h(this.as, {
            style: {
                'white-space': this.wrap ? 'initial' : 'nowrap',
            },
            class: {
                [utility.huge]: this.size === 'huge',
                [utility.bigger]: this.size === 'bigger',
                [utility.big]: this.size === 'big',
                [utility.small]: this.size === 'small',
                [utility.bold]: this.weight === 'bold',
            },
        }, this.$slots.default ? this.$slots.default() : '');
    },
});
